/**
 * Place for common things
 * Test file for this service you can fin in the specs web-app/test/unit/spec/services/utilsSpec.js
 */

angular.module('qkr')
    .service('utils', ['$rootScope', 'appConfig', '$uibModal', '$locale', '$timeout', 'gettextCatalog',
    function utils($rootScope, appConfig, $uibModal, $locale, $timeout, gettextCatalog) {

    this.apiUrl = function(request) {
    	const urlStart = request.indexOf('/api');

        return request.substring(urlStart);
    };

    this.downloadBase64 = (base64Content, fileName='download.bin', mimeType='application/octet-stream') => {
        if (!window.Blob) {
            window.Blob = function(ab, conf){
                const bb = new (window.WebKitBlobBuilder || window.MozBlobBuilder);
                ab.forEach(function(buff){
                    bb.append(buff);
                });
                return bb.getBlob(conf.type);
            };
        }

        var src = atob(base64Content).split("");
        var aBuffer = new ArrayBuffer(src.length);
        var i8a = new Uint8Array(aBuffer);
        src.forEach(function(c, i){
            i8a[i] = c.charCodeAt(0) & 0xff;
        });

        var blob = new Blob([aBuffer], {type: mimeType});

        if (window.navigator.msSaveBlob) { // // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
            window.navigator.msSaveOrOpenBlob(blob, fileName);
        } else {
            var a = $('<a style="display: none;"/>');
            var url = (window.webkitURL || window.URL).createObjectURL(blob);
            a.attr("href", url);
            a.attr("download", fileName);
            $("body").append(a);
            a[0].click();
            window.URL.revokeObjectURL(url);
            a.remove();
        }
    };

    this.getParameterUrl = (queryString, paramName) => {
        const paramList = queryString.slice(1).split('&');

        const buildObject = (item) => {
            const value = this.toValidateString(decodeURIComponent(item.slice(item.indexOf('=') + 1)));
            return {
                [paramName]: value
            };
        };
        // error=Session+Expired#/mastercard/merchants
        const removeNoParam = (item) => {
            const dashIndex = item.indexOf('#') !== -1 ? item.indexOf('#') : item.length;
            return item.slice(0,  dashIndex);
        }

        const result =
            paramList
                .map(removeNoParam)
                .filter((item) => item.indexOf(paramName) !== -1)
                .map(buildObject);

        return result.length > 0 ? result[0] : null;
    };

    this.toValidateString = (dirtyString) => {
        const result = dirtyString.replace(/[|&;$%@"<>()+,]/g, " ").trim();

        return result !== '' ? result : null;
    };

    //similar lodash function _.get
    //returns undefined if the key is undefined
    this.get = (obj, key) => {
        if(key) {
            return key
                    .split('.')
                    .reduce((o, x) => (typeof o === 'undefined' || o === null) ? o : o[x], obj);
        } else {
            null;
        }
    };

    // This function based is on PO files and what the server gives to app.js
    // If the browser gives the locale = 'es' and there is a PO file 'es_MX' the function should returns the PO of that
    // Language
    // E.g: if the locale is 'es' and there is a spanish PO file 'es_CO' , it should returns the the string es_PO
    // There is a spec for service utilsSpec.js, if change this function should run the test because is not automated yet
    this.getLocale = function(locale, poFileNames) {
        let result = 'en', found = false;

        if (locale) {
            // Check if there is the same locale in the array, eg: es === es id is true just return currentLocale
            if (poFileNames.indexOf(locale) !== -1) {
                result = locale;
                found = true;
            }

            if (!found) {
                // Browser locale has country and language e.g: es_CO
                if (locale.split('_').length > 1) {
                    // Didn't find the full string check the country, e.g: current locale es and return es_CO
                    poFileNames.forEach((fileName) => {
                        const country = locale.split('_')[0];

                        // Checks each string country in the array
                        const itemCountry = fileName.split('_')[0];

                        // It can get into more the once, eg: locale es_CO; poFileNames [es, es_AR],
                        // Just comparing the countries here, which should returns ?
                        if (country === itemCountry) {
                            result = fileName;
                            found = true;
                        }
                    });
                } else {
                    const currentLocale = locale.split('_')[0];
                    // If is not in the array check the country, eg: es !== es_CO but should set to es_CO
                    poFileNames.forEach((fileName) => {
                        const country = fileName.slice(0, 2);
                        if (country === currentLocale) {
                            // Return the full file name eg: es_CO, in this case the browser
                            // Has current locale es, but the file is es_CO
                            result = fileName;
                            found = true;
                        }
                    });
                }
            }
        }

        return result;
    };

    this.findItemInList = function(list, id) {
        if (list) {
            const l = list.length;
            for (let i = 0; i < l; i++) {
                if (list[i].id == id) {
                    return list[i];
                }
            }
        }
        return null;
    };

    this.scrollToTop = function() {
        $('body,html').animate({scrollTop: 0}, 350);
    };

    this.scrollTo = function(topOffset) {
        $('body').animate({scrollTop: topOffset}, 350);
    };

    this.serverDateToDate = function(serverDate) {
         if (dateFormat === null)
            dateFormat = SERVER_DATE_PATERN;

        if (!this.hasNoValue(serverDate)) {
            const dateSplit = serverDate.split('-');
            const objDate = new Date(dateSplit[1] + ' ' + dateSplit[0] + ', ' + dateSplit[2]);
            return objDate;
        }
        return null;
    };

    this.setFocus = function(elementId) {
        const element = angular.element('#' + elementId)[0];

        if(element) {
            $timeout(() => {
                element.focus();
            }, 0);
        }

    };

    /**
     * Tests for a number which can include a decimal place
     * @param num - the number to check.
     * @param decimalSeparator - the decimal separator for the current locale.
     * @return {boolean}
     */
    this.isNumber = function(num) {
        return new RegExp('[\\d\\s' + $locale.NUMBER_FORMATS.DECIMAL_SEP + ']').test(num);
    };

    /**
     * Tests for a numeric value
     * @param num - the number to check
     * @return {boolean}
     */
    this.isNumeric = function(num) {
        return /[\d\s]/.test(num);
    };

    /**
     * Check is the value is a decimal
     * @param num - the number to check
     * @return {boolean}
     */
    this.isDecimal = function(num) {
        return num % 1 != 0;
    };

    this.twoDecimalPlaces = function(n) {
        return n > 9 ? '' + n : '0' + n;
    };

    this.isHex = function(text) {
        return /^[0-9A-Fa-f]+$/.test(text);
    };

    this.isEven = function(text) {
        return text.length % 2 == 0;
    };

    /**
     * Return a map with just id set (for identifying an object to server)
     */
    this.idOnly = function(obj) {
        return {id: obj.id};
    };

    /**
     * Return a copy of a map with some properties removed
     */
    this.withoutProperties = function(obj, fields) {
        const ret = {};
        for (const key in obj) {
            if (fields.indexOf(key) == -1) {
                ret[key] = obj[key];
            }
        }
        return ret;
    };

    /*
     * Create a shallow copy of an array
     * Note that the objects in the array are not cloned so the references in copyArray will point
     * to the same objects as arrayToCopy
     */
    this.copyArray = function(arrayToCopy) {
        const copyArray = [];
        for (let i = 0; i < arrayToCopy.length; i++) {
            copyArray.push(arrayToCopy[i]);
        }

        return copyArray;
    };

    /**
     * @deprecated Please do not use this, the function mixes types, pretends an empty array is not a value etc.
     */
    this.hasNoValue = function(value) {
        if (typeof (value) === 'undefined' || value == null || value.length == 0) {
            return true;
        }
        return false;
    };

    this.isEmpty = function(obj) {
        // Null and undefined are "empty"
        if (obj == null) return true;

        // Assume if it has a length property with a non-zero value
        // That that property is correct.
        if (obj.length > 0) return false;
        if (obj.length === 0) return true;

        // Otherwise, does it have any properties of its own?
        // Note that this doesn't handle
        // ToString and valueOf enumeration bugs in IE < 9
        for (const key in obj) {
            if (hasOwnProperty.call(obj, key)) return false;
        }

        return true;
    };

    /** Get a single property from each object in a list */
    this.propToList = function(objectList, propName) {
        const ret = [];
        for (let i = 0; i < objectList.length; i++) {
            ret.push(objectList[i][propName]);
        }
        return ret;
    };

    /** Get list of coupons and menus and loyalty cards */
    this.summarizeListWithCouponAndMenuNames = function(list, deactivateCoupon) {
        const couponList = [];
        const loyaltyCardList = [];
        const menuList = [];
        let i;
        let str = '\n';
        for (i = 0; i < list.length; i++) {
            if (list[i].prodGroup.deleted) {
                list.splice(i, 1);
            }
        }

        if (list.length == 0) {
            return 'no items';
        }

        for (i = 0; i < list.length; i++) {
            if (list[i].name) {
                if (list[i].prodGroup.name.indexOf('COUPON:') == 0) {
                    if (list[i].prodGroup.isRewardCoupon) {
                        if (list[i].prodGroup.name.indexOf('_') > -1 && list[i].prodGroup.name.indexOf(':') > -1) {
                            const name = list[i].prodGroup.name.split('_')[0].split(':')[1];
                            if (loyaltyCardList.indexOf(name) == -1) {
                                loyaltyCardList.push(name);
                            }
                        }
                    } else {
                        couponList.push(list[i].prodGroup.name.split(':')[1]);
                    }
                } else {
                    menuList.push(list[i].prodGroup.name);
                }
            }
        }

        if (menuList.length > 0) {
            str = str + ' \n ' + gettextCatalog.getString('The following menu(s) will be affected:') + '\n';
            str = str + '\u2022 \'' + menuList[0] + '\'';
            for (i = 1; i < menuList.length; i++) {
                str = str + ', \'' + menuList[i] + '\'';
            }
        }

        if (couponList.length > 0) {
            if (deactivateCoupon) {
                str = str + ' \n' +
                    gettextCatalog
                        .getString('The following coupon(s) will be affected and may be automatically deactivated:') +
                    ' \n';
            } else {
                str = str + ' \n' + gettextCatalog.getString('The following coupon(s) will be affected and may be automatically activated:') + ' \n';
            }
            str = str + '\u2022 \'' + couponList[0] + '\'';
            for (i = 1; i < couponList.length; i++) {
                str = str + ', \'' + couponList[i] + '\'';
            }
        }

        if (loyaltyCardList.length > 0) {
            str = str + ' \n' + gettextCatalog.getString('The following Loyalty Card(s) will be affected:') + ' \n';
            str = str + '\u2022 \'' + loyaltyCardList[0] + '\'';
            for (i = 1; i < loyaltyCardList.length; i++) {
                str = str + ', \'' + loyaltyCardList[i] + '\'';
            }
        }

        return str;
    };

    /** Given a list of strings return a summary like "a, b, c and 4 more items" */
    this.summarizeListWithMenuNames = function(list, n) {
        let i;
        let extra;
        for (i = 0; i < list.length; i++) {
            if (list[i].prodGroup.deleted) {
                list.splice(i, 1);
            }
        }
        
        if (list.length == 0) {
            return 'no items';
        }
        let str = '\'' + list[0].prodGroup.name + '\'';
        for (i = 1; i < list.length; i++) {
            if (i < n) {
                if (list[i].name)
                   str = str + ', \'' + list[i].prodGroup.name + '\'';
            }
        }
        if (list.length > n) {
            extra = (list.length - n);
            if (extra > 1)
            str = str + ' and ' + (list.length - n) + ' others';
            else
                str = str + ' and ' + (list.length - n) + ' other';
        }
        return str;
    };
    
    /**
     * Menu-specific functions
     */
    this.getMenuType = function(menu) {
        if (!this.hasNoValue(menu) && !this.hasNoValue(menu.availability)) {
            if (menu.availability.isPreorderable === true && menu.availability.fixedPreorderType !== true) {
                return 'recurring';
            } else if (menu.availability.isPreorderable === true && menu.availability.fixedPreorderType === true) {
                return 'fixed';
            }
        }
        return 'realtime';
    };
    this.fixedMenuHasNoAvailability = function(menu) {
        if (this.hasNoValue(menu.availability.expiryDateStr)) {
                return true;
        }
        return false;
    };
    this.fixedMenuItemHasMissingAvailability = function(menu, menuItem) {
        if (this.fixedMenuHasNoAvailability(menu)) {
            if (this.hasNoValue(menuItem.availability) ||
                this.hasNoValue(menuItem.availability.expiryDateStr) ||
                this.hasNoValue(menuItem.availability.cutoffOffsetInMinutes))

                return true;
        }
        return false;
    };

    this.formatCutOff = function(cutoffOffsetInMinutes) {
        const cutoff = cutoffOffsetInMinutes;

        let cutoffhrs = cutoff % 1440;
        const rolloveroffset = cutoffhrs < 0 ? 24 * 60 : 0;
        cutoffhrs = rolloveroffset + cutoffhrs;
        const time_cutoff = cutoffhrs;

        const time_cutoff_hours = Math.floor(time_cutoff / 60);
        const time_cutoff_minutes = time_cutoff % 60;

        return this.twoDecimalPlaces(time_cutoff_hours) + ':' + this.twoDecimalPlaces(time_cutoff_minutes);
    };

    this.getCutOff = function(cutoffOffsetInMinutes) {
        const cutoff = cutoffOffsetInMinutes;

        let cutoffhrs = cutoff % 1440;
        const rolloveroffset = cutoffhrs < 0 ? 24 * 60 : 0;
        const cutoff_days = Math.floor(Math.abs(cutoff * 1.0 / 1440.0)) + rolloveroffset / 1440;
        cutoffhrs = rolloveroffset + cutoffhrs;
        const time_cutoff = cutoffhrs;

        const time_cutoff_hours = Math.floor(time_cutoff / 60);
        const time_cutoff_minutes = time_cutoff % 60;

        return {cutoffHour: time_cutoff_hours, cutoffMinutes: time_cutoff_minutes, cutoffDays: cutoff_days};
    };

    this.checkSSL = function(imageUrl) {
        if (!this.hasNoValue(imageUrl)) {
            if (appConfig.useSSL) {
                imageUrl = imageUrl.replace('http:', 'https:');
            } else {
                imageUrl = imageUrl.replace('https:', 'http:');
            }
        }
        return imageUrl;
    };

    /** Given comma separated list of days, sets the selected flag in days map */
    this.setSelectedDays = function(commaSeparatedDayList, days) {
        for (let i = 0; i < 7; ++i) {
            const day = days[i].name;
            if (commaSeparatedDayList.indexOf(day) == -1) {
                days[i].selected = false;
            } else {
                days[i].selected = true;
            }
        }
    };

    /** Form a comma seperated list of days from the selected states of days map */
    this.getSelectedDaysList = function(days) {
        const selectedDays = [];

        for (let i = 0; i < 7; ++i) {
            if (days[i].selected) {
                selectedDays.push(days[i].name);
            }
        }

        return selectedDays.join(',');
    };
    
    this.modalInstanceFeedback = function(params) {
    	return $uibModal.open({
            template: require('../templates/feedback/modal.html'),
            controller: 'FeedbackModalController',
            windowClass: 'fade',
            backdrop: 'static',
  	        resolve: {
  	        	params() {
  	        		return params;
  	        	}
  	        }
        });
    };
    
    this.floorNumberToSpecifiedDecimalPlaces = function(numberToFloor, decimalPlaces) {
    	const expanded = (numberToFloor * Math.pow(10, decimalPlaces));
    	const floored = Math.floor(expanded);
    	const contracted = floored / Math.pow(10, decimalPlaces);
    	return contracted;
    };
    
    this.roundNumberToSpecifiedDecimalPlaces = function(numberToRound, decimalPlaces) {
    	return (Math.round(numberToRound * Math.pow(10, decimalPlaces)) / Math.pow(10, decimalPlaces));
    };
    
    this.getNumberOfDecimalPlaces = function(num) {
    	const match = ('' + num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
    	
    	if (!match) {
    		return 0;
    	}
    	
    	return Math.max(0,
	       // Number of digits right of decimal point.
	       (match[1] ? match[1].length : 0)
	       // Adjust for scientific notation.
	       - (match[2] ? +match[2] : 0));
	};

    this.multiplyXBy10PowerY = function(x, y) {
        const numberOfDecimalPlaces = this.getNumberOfDecimalPlaces(x) + (y * -1);
        const xMultiplied = parseFloat(x) * Math.pow(10, Number(y));
        const rounded = this.roundNumberToSpecifiedDecimalPlaces(xMultiplied, numberOfDecimalPlaces);

        return rounded;
    };
    
    // Used to convert dd-MMM-yyyy to date obj. Firefox cannot create date obj in dd-MMM-yyyy formate
    this.serverDateStringtoDate = function(dateString) {
        let day,
            month,
            year;

        // IS ALREADY OBJ why are you here?
        if (typeof (dateString) === 'object') {
            return angular.copy(dateString);
        }

        // IS A NUMBER
        if (typeof (dateString) === 'number') {
            return new Date(dateString);
        }

        // ASSUMING dd-MMM-yyyy or yyyy-MMM-dd aka BEST STYLE
        if (dateString.match(/[0-9]{2}[-][a-zA-Z]{3}[-][0-9]{4}/) ||
            dateString.match(/[0-9]{4}[-][a-zA-Z]{3}[-][0-9]{2}/)) {
            day = dateString.match(/[0-9]{2}/);
            month = this.shortEnglishMonthToMonth(dateString.match(/[a-zA-Z]{3}/));
            year = dateString.match(/[0-9]{4}/);

            return new Date(year, month, day);
        } else {
            // ASSUMING d-MMM-yyyy
            if (dateString.match(/[0-9]{1}[-][a-zA-Z]{3}[-][0-9]{4}/)) {
                day = dateString.match(/[0-9]{1}/);
                month = this.shortEnglishMonthToMonth(dateString.match(/[a-zA-Z]{3}/));
                year = dateString.match(/[0-9]{4}/);

                return new Date(year, month, day);
            }
        }

        return null;
    };

    // DATE OBJ TO SERVER STRING
    this.dateToServerDateString = function(date) {
        if (typeof (date) === 'object' && date != null) {
            const dateString = date.getDate() + '-' + this.monthToShortEnglishMonth(date.getMonth()) +
                '-' + date.getFullYear();

            return dateString;
        }

        if (typeof (date) === 'string') {
            return this.dateToServerDateString(new Date(date));
        }

        if ((typeof (date) === 'number') && (!isNaN(date))) {
            return this.dateToServerDateString(new Date(date));
        }

        return null;
    };

    this.timeToServerTimeString = function(time) {
        if (typeof (time) === 'object' && time != null) {
            let timeString = '';
            timeString = this.padTime(time.getHours()) + ':' + this.padTime(time.getMinutes()) + ':' +
                this.padTime(time.getSeconds());
            return timeString;
        }

        if (typeof (time) === 'string') {
            return this.timeToServerTimeString(new Date(time));
        }

        if ((typeof (time) === 'number') && (!isNaN(time))) {
            return this.dateToServerDateString(new Date(time));
        }

        return null;
    };

    this.dateTimeToServerDateTimeString = function(date, time) {
        let timeString = this.timeToServerTimeString(time);
        if (timeString == null) {
            timeString = '00:00:00';
        }
        return (this.dateToServerDateString(date) + ' ' + timeString);
    };

    this.shortEnglishMonthToMonth = function(month) {
        month = month.toString().toLowerCase();

        switch (month) {
            case 'jan':
                return 0;
            case 'feb':
                return 1;
            case 'mar':
                return 2;
            case 'apr':
                return 3;
            case 'may':
                return 4;
            case 'jun':
                return 5;
            case 'jul':
                return 6;
            case 'aug':
                return 7;
            case 'sep':
                return 8;
            case 'oct':
                return 9;
            case 'nov':
                return 10;
            case 'dec':
                return 11;
        }
        return null;
    };

    this.monthToShortEnglishMonth = function(month) {
        switch (month) {
            case 0:
                return 'Jan';
            case 1:
                return 'Feb';
            case 2:
                return 'Mar';
            case 3:
                return 'Apr';
            case 4:
                return 'May';
            case 5:
                return 'Jun';
            case 6:
                return 'Jul';
            case 7:
                return 'Aug';
            case 8:
                return 'Sep';
            case 9:
                return 'Oct';
            case 10:
                return 'Nov';
            case 11:
                return 'Dec';
        }
        return null;
    };

    this.padTime = function(time) {
        time = time.toString();
        if (time.length == 2) {
            return time;
        } else if (time.length == 1) {
                return '0' + time;
            } else {
                return '00';
            }
    };

    this.getDaysOfWeekWithSelected = function() {
        const week = this.localizeWeek([
            {displayName: gettextCatalog.getString('Sun'), name: 'Sun', selected: true},
            {displayName: gettextCatalog.getString('Mon'), name: 'Mon', selected: true},
            {displayName: gettextCatalog.getString('Tue'), name: 'Tue', selected: true},
            {displayName: gettextCatalog.getString('Wed'), name: 'Wed', selected: true},
            {displayName: gettextCatalog.getString('Thurs'), name: 'Thu', selected: true},
            {displayName: gettextCatalog.getString('Fri'), name: 'Fri', selected: true},
            {displayName: gettextCatalog.getString('Sat'), name: 'Sat', selected: true}
        ]);

        week[week.length - 1].selected = false;
        week[week.length - 2].selected = false;
        return week;
    };

    this.getDaysOfWeek = function() {
        const week = this.localizeWeek([
            {displayName: gettextCatalog.getString('Sun'), name: 'Sun'},
            {displayName: gettextCatalog.getString('Mon'), name: 'Mon'},
            {displayName: gettextCatalog.getString('Tue'), name: 'Tue'},
            {displayName: gettextCatalog.getString('Wed'), name: 'Wed'},
            {displayName: gettextCatalog.getString('Thurs'), name: 'Thu'},
            {displayName: gettextCatalog.getString('Fri'), name: 'Fri'},
            {displayName: gettextCatalog.getString('Sat'), name: 'Sat'}
        ]);

        return week;
    };

    // Sets week to begin with the correct day. Assuming we getting a week beginning with Sunday
     //TODO this need to be refactor!! accessing rootScope from here!! bad!
    this.localizeWeek = function(weekArray, merchantInfo) {
        const mi = merchantInfo ? merchantInfo : $rootScope.merchantInfo;
        let reorderedWeek = weekArray;
        let i = 0;
        let j;
        let weekStartDay= 1;
        // avoid undefined access
        if(mi && mi.contactDetails && mi.contactDetails.country) {
            weekStartDay = mi.contactDetails.country.weekStartingDay
        }

        reorderedWeek = [];
        for (j = weekStartDay; j < weekArray.length; j++, i++) {
            reorderedWeek[i] = weekArray[j];
        }
        for (j = 0; j < weekStartDay; j++, i++) {
            reorderedWeek[i] = weekArray[j];
        }
        return reorderedWeek;
    };

    this.convertStringArrayToStringWrapperArray = function(stringArray) {
        const stringWrapperArray = [];
        const self = this;

        angular.forEach(stringArray, (stringInArray) => {
            stringWrapperArray.push(self.convertStringToStringWrapper(stringInArray));
        });

        return stringWrapperArray;
    };

    this.convertStringToStringWrapper = function(stringToConvert) {
        return {
            value: stringToConvert
        };
    };

    this.toInt = function(number) {
        return Math[number < 0 ? 'ceil' : 'floor'](number);
    };

    // Public api
    // taken from chromium
    // https://stackoverflow.com/questions/46155/how-to-validate-email-address-in-javascript
    this.isEmailValid = function(email){
        const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return regex.test(email);
    };
    return this;
}]);



// WEBPACK FOOTER //
// ./src/services/utils.js